module.exports = __webpack_public_path__ + "img/beer_id-38.727e82a5.png";